<template>
  <img class="banner-image" src="../assets/toppic/图片_01.jpg"/>
  <div class="panel-div">
    <div class="title-panel-name">
      <div class="item-group-div"  v-for="(item,index) in productTypeList" :key="item.id">
        <router-link class="item-group-div" :to="'/productgroup/'+item.id" :underline="false">
          <span :class="{'panel-span active':activeName == item.groupName,'panel-span':activeName != item.groupName,}" >{{item.groupName}}</span>
          <span v-if="index < productTypeList.length -1">|</span>
        </router-link>
      </div>
    </div>
  </div>
  <div class="home-index-product">
    <el-row>
      <el-col v-for="item in websitescreensList" :key="item" :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
        <router-link :to="'/product/'+item.id" :underline="false" style="text-decoration: none;">
          <div class="product-body">
            <div class="img-div">
              <img :src="baseImageUrl+item.smallImages" />
            </div>
            <p>{{item.name}}</p>
          </div>
        </router-link>
      </el-col>
    </el-row>
  </div>
  <el-row>
    <el-col  v-if="!websitescreensList || websitescreensList.length == 0">
      <el-empty :description="locale[language.code].companynews.emptyTips"></el-empty>
    </el-col>
  </el-row>
</template>

<script>
import {
  producttype,websitescreenssearch
} from '@/api/ProductGroup';
import locale from "@/locale/locale";

export default {
  name: 'ProductGroup',
  data(){
    return{
      locale:locale,
      hasLoad:false,
      language:null,
      productTypeId:null,
      activeName:null,
      activeIndex:null,
      baseImageUrl:process.env.VUE_APP_FILE_API,
      productTypeList:[],
      websitescreensList:[]
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");
    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    initData() {
      this.producttypeId = this.$route.params.id;
      producttype({id:this.language.id}).then(res => {
        console.log(res);
        this.productTypeList = res.data;

        for(var tempIndex in this.productTypeList){
          if(this.productTypeList[tempIndex].id == this.producttypeId){
            this.activeName = this.productTypeList[tempIndex].groupName;
            this.activeIndex = tempIndex;
          }
        }
      });

      this.getProductData();
    },
    getProductData(){
      var data = {
        languageId:this.language.id,
        producttypeId:this.producttypeId
      };
      websitescreenssearch(data).then(res => {
        console.log(res);
        this.websitescreensList = res.data;
        for(var tempIndex in this.websitescreensList){
          this.websitescreensList[tempIndex].smallImages = this.websitescreensList[tempIndex].smallImages.split(",")[0];
        }
      });
    },
    changePanel(index) {
      this.activeName = this.productTypeList[index].groupName;
      this.producttypeId = this.productTypeList[index].id;
      this.activeIndex = index;
      this.getProductData();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-div{
  padding:20px 35px;
  text-align: left;
}
.panel-div .title-panel-name{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width:auto;
  overflow-x: scroll;
  padding:0px 10px;
  scrollbar-width: thin; /* auto | thin | none */
  scrollbar-color: #4CAF50 #f1f1f1; /* 滑块颜色 轨道颜色 */
  margin:20px 0px;
  margin-bottom: 60px;
}

.title-panel-name::-webkit-scrollbar {
  height:2px;
}

.title-panel-name::-webkit-scrollbar-thumb {
  background: #E1E1E1;
  border-radius: 3px;
}

@media (max-width: 720px) {
  .panel-div .title-panel-name {
    justify-content: flex-start!important;
  }
}

.panel-div .title-panel-name .panel-span{
  display: inline-block;
  background-color: #EFEFEF;
  white-space: nowrap;
  margin:6px 13px;
  padding:8px 18px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  color:#303133;
}

.item-group-div{
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.panel-div .title-panel-name .panel-span:hover{
  font-weight: 700;
  color:#1890ff;
  background-color:#e9f4ff;
}
.panel-div .title-panel-name .active{
  font-weight: 700;
  color:#1890ff;
  background-color:#e9f4ff;
}

.home-index-product .product-body{
  padding:4px 6px;
}
.home-index-product .product-body  .img-div{
  border:1px solid #E4E7ED;
  padding:8px 12px;
  border-radius: 6px;
}
.home-index-product .product-body .img-div img{
  width:100%;
}


</style>
